import { render, staticRenderFns } from "./BarChartRevenueLastTwelveMonths.vue?vue&type=template&id=160a315a&scoped=true"
import script from "./BarChartRevenueLastTwelveMonths.vue?vue&type=script&lang=js"
export * from "./BarChartRevenueLastTwelveMonths.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160a315a",
  null
  
)

export default component.exports